<template>
  <div class="device-param-drawer-dialog-bd">
    <el-drawer size="1000px" :title="model.title" :visible="visible" :before-close="closeDialog" class="device-param-drawer" :append-to-body="true">
      <div class="info-content">
        <div class="title" v-if="model.desc">
          <i class="icon icon-tishi"></i>
          {{ model.desc }}
        </div>
        <div class="info-content-box" >
          <div class="info-box">
            <ul class="information">
              <li class="line" :class="{ current: item.componentCode === childComponentCode }" v-for="item in paramList" :key="item.componentCode" @click="changeComponent(item)">
                {{ item.componentName }}
              </li>
            </ul>
          </div>
          <div class="table-box">
            <!-- 指令参数 -->
            <h2 class="table-title">
              <!-- 刷新时间 -->
              <div class="time">
                <span class="text">
                  {{ $t('dms_deviceParamModemDrawer.yjqtbsj') }}
                  {{ momentAmPm($momentLocal(uploadTime) || '-') }}
                </span>
              </div>
              <!-- 离线任务 -->
              <div class="task" v-if="Object.keys(offlineTask).length !== 0">
                <span class="text">
                  {{ $t('dms_deviceParamModemDrawer.wei_wan_cheng_ren_wu') }}
                </span>
                <a class="click" @click="jumpFirmwareTask">
                  {{ $t('dms_deviceParamModemDrawer.dian_ji_cha_kan') }}
                </a>
              </div>
            </h2>
            <!-- 刷新数据，修改配置 -->
            <h2 class="table-title">
              {{ childComponentName }}
              <!-- 账单不需要修改账款 -->
              <!-- :disabled="Object.keys(offlineTask).length !== 0" -->
              <!-- configBill-账单配置  configSiteInfo-站点配置-->
              <el-button style="float: right" size="mini" @click="changeSetting()" v-if="childComponentCode !== 'configBill'&&childComponentCode!=='configSiteInfo' || (childComponentCode==='configSiteInfo' && funView.boardDetail_configSiteInfo)">
                <i class="icon icon-bianji"></i>
                {{ $t('dms_deviceParamModemDrawer.xiu_gai_pei_zhi') }}
              </el-button>
              <el-button @click="refreshCompoment" style="float: right" size="mini" v-if="childComponentCode !== 'configBill'" :disabled="asyncing">
                <i class="icon icon-shuaxin"></i>
                {{ $t('dms_deviceParamModemDrawer.shua_xin_shu_ju') }}
                <span v-if="asyncing">（{{ $t('dms_deviceParamModemDrawer.shua_xin_zhong')}}... ）</span>
              </el-button>
            </h2>
            <!-- 有数据才显示 -->
            <h2 class="table-title tips-title" v-if="childComponentDesc && childComponentCode !== 'configBill'">
              <div class="tip">
                <i class="icon icon-tishi"></i>
                {{ childComponentDesc }}
              </div>
            </h2>
            <!--
              有项目分类
            -->
            <custom-table
              v-if="childComponentCode !== 'configBill' && isTopicTslGroup"
              :boderRight="true"
              :data="paramItemList"
              :loading="isLoading"
              :slots="['dataValue']"
              tableCode="device_param_drawer_class"
              height="100%"
              :key="1"
              :span-method="objectSpanMethod"
            >
              <template v-slot:dataValue="scope">
                <span v-if="scope.row.dicGroup">{{ getDicValue(scope.row.dicGroup, scope.row.dataValue) }}</span>
                <span v-else-if="`${scope.row.widgetType}` === '5'">{{ formatHhmmStr(scope.row.dataValue) }}</span>
                <span v-else-if="`${scope.row.widgetType}` === '8'">{{ formatDateTime(scope.row.dataValue) }}</span>
                <span v-else>{{ scope.row.dataValue || '-' }}</span>
                <!-- {{ scope.row.dataValue }} -->
              </template>

              <!-- <el-table-column
                :label="$t('com_action"
                fixed="right"
                v-if="!!tableColumn.length"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="changeSetting(scope.row)"
                    :disabled="Object.keys(offlineTask).length !== 0"
                  >
                    {{
                      $t('page_content_change_setting
                    }}
                  </el-button>
                </template>
              </el-table-column> -->
            </custom-table>
            <!--没分类-->
            <custom-table
              v-if="childComponentCode !== 'configBill' && !isTopicTslGroup"
              :boderRight="true"
              :data="paramItemList"
              :loading="isLoading"
              :slots="['dataValue']"
              tableCode="device_param_drawer"
              height="100%"
              :key="2"
            >
              <template v-slot:dataValue="scope">
                <span v-if="scope.row.dicGroup">{{ getDicValue(scope.row.dicGroup, scope.row.dataValue) }}</span>
                <span v-else-if="`${scope.row.widgetType}` === '5'">{{ formatHhmmStr(scope.row.dataValue) }}</span>
                <span v-else-if="`${scope.row.widgetType}` === '8'">{{ formatDateTime(scope.row.dataValue) }}</span>
                <span v-else>{{ scope.row.dataValue || '-' }}</span>
              </template>
            </custom-table>
          </div>
        </div>
      </div>
    </el-drawer>
    <deviceParamDialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="updateParamList()"></deviceParamDialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import deviceParamDialog from './device_paramModem_dialog.vue';

export default {
  components: {
    deviceParamDialog,
  },
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: '',
        };
      },
    },
    funView: {
      type: Object,
    },
    value: {
      type: Boolean,
      default: false,
    },
    data: [String, Object, Array],
    // taskId: [Number, String]
  },

  data() {
    return {
      visible: false,
      modemSn: '',
      componentCode: '',
      componentGroup: '',
      paramList: [],
      childComponentName: '',
      childComponentCode: '',
      childComponentDesc: '',
      structureId: '',
      paramItemList: [],
      uploadTime: '',

      paramTableColumn: [],

      dialogVisible: false,
      dialogData: {},
      dialogModel: {},

      // 字典name值
      iot_cmd_task_service_type: {},

      offlineTask: {},
      spanArr: [],
      asyncing: false,
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    isTopicTslGroup() {
      return this.paramItemList.find(i => !!i.topicTslGroup);
    },
  },
  methods: {
    // 初始化
    init: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      // 赋值产品id
      this.taskId = this.data.taskId;
      this.modemSn = this.data.modemSn;
      this.componentCode = this.data.componentCode;
      this.componentGroup = this.data.componentGroup;
      // 查字典
      // this.getDictionary('iot_cmd_task_service_type', (data) => {
      //   this.iot_cmd_task_service_type = this.$transformDicValue(
      //     data.iot_cmd_task_service_type
      //   );
      // });
      this.getParamList();
    },
    // 刷新组件
    refreshCompoment: function () {
      this.$getJSON(apis.modemBatteryRefresh, {
        modemSn: this.modemSn,
        componentCode: this.childComponentCode,
      }).then(() => {
        this.asyncing = true;
        setTimeout(() => {
          this.asyncing = false;
          this.getParamItemList();
        }, 10000);
      });
    },
    updateParamList: function () {
      this.asyncing = true;
      setTimeout(() => {
        this.asyncing = false;
      }, 10000);
    },
    // 获取左侧参数列表
    getParamList: function () {
      this.$getJSON(apis.modemBatteryParamlist, {
        modemSn: this.modemSn,
        componentCode: this.componentCode,
        testType: this.data.testType,
      }).then((res) => {
        this.paramList = res.data;
        this.childComponentName = res.data[0].componentName;
        this.childComponentCode = res.data[0].componentCode;
        this.childComponentDesc = res.data[0].componentDesc;
        // this.structureId = res.data[0].structureId;
        this.getParamItemList();
        // 离线任务
        this.getOfflineTask();
      });
    },
    // 右侧参数
    getParamItemList: function () {
      this.$getJSON(apis.modemBatteryParamItemList, {
        modemSn: this.modemSn,
        componentCode: this.childComponentCode,
        testType: this.data.testType,
      }).then((res) => {
        this.paramItemList = res.data.filter(i => i.dataCode !== 'uploadTime');
        this.getSpanArr(this.paramItemList);
        const uploadTimeItem = res.data.filter(i => i.dataCode === 'uploadTime');
        this.uploadTime = uploadTimeItem.length ? uploadTimeItem[0].dataValue : '';
      });
    },
    // 点击部件
    changeComponent: function (item) {
      this.childComponentName = item.componentName;
      this.childComponentCode = item.componentCode;
      this.childComponentDesc = item.componentDesc;
      // this.structureId = item.structureId;
      //   账单不用请求 不用重复获取账单数据
      // if (this.childComponentCode !== 'configBill') {
      this.getParamItemList();
      // }
      this.getOfflineTask();
    },
    // 修改参数弹窗
    changeSetting: function () {
      this.dialogModel.title = this.childComponentName;
      this.dialogModel.type = 'edit';
      this.dialogModel.data = {
        modemSn: this.modemSn,
        // structureId: this.structureId,
        componentCode: this.childComponentCode,
        componentGroup: this.componentGroup,
        isModem: true,
      };
      this.dialogVisible = true;
    },

    // 查询离线任务
    getOfflineTask: function () {
      this.$getJSON(apis.commandTaskModemOfflineTask, {
        modemSn: this.modemSn,
        componentCode: this.childComponentCode,
      }).then((res) => {
        this.offlineTask = res.data || {};
      });
    },

    // 跳转到任务管理
    jumpFirmwareTask() {
      this.closeDialog();
      // 清除缓存
      this.clearKeepAlive('firmwareTask');
      this.jump('/iot/firmwareTask', {
        topicCode: this.offlineTask.topicCode,
        protocolId: this.offlineTask.protocolId,
        taskId: this.offlineTask.taskId,
        productCode: this.offlineTask.productCode,
        tcpVersion: this.offlineTask.tcpVersion,
        seeStack: true,
      });
    },
    getSpanArr() {
      this.spanArr = [];
      this.paramItemList.forEach((item, i) => {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (item.topicTslGroup === this.paramItemList[i - 1].topicTslGroup) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      });
    },
    // 合并列
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      return false;
    },
    cellMerge: function ({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      return false;
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close');
      }, 250);
    },
    saveProtocolConfig: function () {
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.device-param-drawer {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed !important;

  span[role='heading']:focus {
    outline: none;
  }
  .el-drawer__header {
    padding: 0;
    padding-left: 18px;
    line-height: 50px;
    font-size: 14px;
    font-weight: bold;
    color: #495057;
    border-bottom: 1px solid #e9ebec;
    margin-bottom: 0;
    padding-right: 20px;

    .el-icon-close {
      font-size: 14px;
      font-weight: bold;
    }
  }
  .el-drawer__body {
    position: relative;
    padding: 0px;

    .info-content {
      display: flex;
      flex-direction: column;
      height: 100%;
      .title {
        margin: 24px 24px 10px;
        padding-left: 10px;
        background: rgba(249, 200, 81, 0.15);
        border-radius: 2px;
        font-size: 12px;
        line-height: 32px;
        color: rgba(108, 117, 125, 1);
        .icon {
          color: rgba(249, 200, 81, 1);
          margin-right: 10px;
        }
      }
      .info-content-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        overflow: hidden;
        padding: 0px !important;

        .info-box {
          flex: 0 0 210px;
          width: 210px;
          // padding: 13px 0;
          // margin-right: 24px;
          background-color: rgba(248, 249, 251, 1);
          // height: 100%;
          .information {
            .line {
              height: 40px;
              line-height: 40px;
              background: rgba(248, 249, 251, 1);
              color: rgba(73, 80, 87, 1);
              font-size: 12px;
              font-weight: 400;
              cursor: pointer;
              padding-left: 24px;
            }
            .line.current {
              background-color: rgba(255, 255, 255, 1);
              color: rgba(13, 154, 224, 1);
            }
          }
        }
        .table-box {
          padding: 10px 24px 24px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          flex: 1;
          width: 0;
          // overflow-y: auto;
          .table-title {
            height: 28px;
            margin-bottom: 10px;
            font-weight: bold;
            font-size: 12px;
            color: rgba(73, 80, 87, 1);
            line-height: 28px;

            .task,
            .time,
            button {
              float: right;
              margin-left: 10px;
              .text {
                color: rgba(152, 166, 173, 1);
                height: 28px;
                font-size: 12px;
                line-height: 28px;
                font-weight: 400;
              }
              .click {
                color: rgba(13, 154, 224, 1);
                height: 20px;
                font-size: 12px;
                line-height: 20px;
                margin-left: 10px;
                font-weight: 400;
                text-decoration: underline;
                cursor: pointer;
              }
            }
          }
          .tips-title {
            height: 32px;
            line-height: 32px;
            font-weight: normal;
            color: rgba(108, 117, 125, 1);
          }

          // .table-bd {
          //   height: 100%;
          //    flex: 1;
          // overflow-y: auto;
          // }
        }
      }
    }
  }
  .tip {
    padding-left: 10px;
    background: rgba(249, 200, 81, 0.15);
    border-radius: 2px;
    font-size: 12px;
    line-height: 32px;
    color: rgba(108, 117, 125, 1);
    .icon {
      color: rgba(249, 200, 81, 1);
      margin-right: 10px;
    }
  }
}
</style>
